import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { loanRolesApi } from 'app/services/api';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import {
  selectIsSubCompanyUser,
  selectMasterCompanyId,
  selectMasterSubCompanyId,
} from 'store/auth/selectors';

const useLoanRoleExposures = () => {
  const isBroker = useSelector(selectIsSubCompanyUser);
  const companyId = useSelector(selectMasterCompanyId);
  const subCompanyId = useSelector(selectMasterSubCompanyId);

  const [exposures, setExposures] = useState([]);

  useEffectSafeStrictMode(() => {
    if (!isBroker || !companyId || !subCompanyId) {
      return;
    }

    loanRolesApi
      .getLoanRoleExposures({ companyId, subCompanyId })
      .then(({ data }) => setExposures(data || []))
      .catch(() => setExposures([]));
  }, [isBroker, companyId, subCompanyId]);

  const actionableRoleIds = useMemo(
    () => exposures.filter(exposure => !exposure.isRevoked).map(exposure => exposure.loanRoleId),
    [exposures],
  );

  const requiredExposures = useMemo(
    () =>
      exposures
        .filter(exposure => exposure.required && !exposure.isRevoked)
        .map(exposure => ({ loanRoleId: exposure.loanRoleId, name: exposure.name })),
    [exposures],
  );

  return useMemo(
    () => ({ isBroker, actionableRoleIds, requiredExposures }),
    [isBroker, actionableRoleIds, requiredExposures],
  );
};

export default useLoanRoleExposures;
